{
  "schemaVersion": 1,
  "rashiNames": [
    "Mesha",
    "Vrishabha",
    "Mithuna",
    "Karka",
    "Simha",
    "Kanya",
    "Tula",
    "Vrischika",
    "Dhanu",
    "Makara",
    "Kumbha",
    "Meena"
  ],
  "nakshatraNames": [
    "Ashvini",
    "Bharani",
    "Krittika",
    "Rohini",
    "Mrigashira",
    "Ardra",
    "Punarvasu",
    "Pushya",
    "Ashlesha",
    "Magha",
    "Purva Phalguni",
    "Uttara Phalguni",
    "Hasta",
    "Chitra",
    "Swati",
    "Vishakha",
    "Anuradha",
    "Jyeshtha",
    "Mula",
    "Purva Ashadha",
    "Uttara Ashadha",
    "Shravana",
    "Dhanishtha",
    "Shatabhisha",
    "Purva Bhadrapada",
    "Uttara Bhadrapada",
    "Revati"
  ],
  "varaNames": [
    "Adivaram",
    "Somavaram",
    "Mangalavaram",
    "Budhavaram",
    "Guruvaram",
    "Shukravaram",
    "Shanivaram"
  ],
  "tithiNames": [
    "Shukla Pratipat",
    "Shukla Dwitiya",
    "Shukla Tritiya",
    "Shukla Chaturthi",
    "Shukla Panchami",
    "Shukla Shashthi",
    "Shukla Saptami",
    "Shukla Ashtami",
    "Shukla Navami",
    "Shukla Dashami",
    "Shukla Ekadashi",
    "Shukla Dwadashi",
    "Shukla Trayodashi",
    "Shukla Chaturdashi",
    "Pournami",
    "Krishna Pratipat",
    "Krishna Dwitiya",
    "Krishna Tritiya",
    "Krishna Chaturthi",
    "Krishna Panchami",
    "Krishna Shashthi",
    "Krishna Saptami",
    "Krishna Ashtami",
    "Krishna Navami",
    "Krishna Dashami",
    "Krishna Ekadashi",
    "Krishna Dwadashi",
    "Krishna Trayodashi",
    "Krishna Chaturdashi",
    "Amavasya"
  ],
  "tithiWithinPakshaNames": [
    "Pratipat",
    "Dwitiya",
    "Tritiya",
    "Chaturthi",
    "Panchami",
    "Shashthi",
    "Saptami",
    "Ashtami",
    "Navami",
    "Dashami",
    "Ekadashi",
    "Dwadashi",
    "Trayodashi",
    "Chaturdashi",
    "Pournami"
  ],
  "tithiAliases": {
    "Pratipada": 1,
    "Prathama": 1,
    "Shashti": 6,
    "Amavasya": 15
  },
  "karanaRepeating": [
    "Bava",
    "Balava",
    "Kaulava",
    "Taitila",
    "Garaja",
    "Vanija",
    "Vishti"
  ],
  "karanaFixed": {
    "0": "Kinstughna",
    "57": "Shakuni",
    "58": "Chatushpada",
    "59": "Naga"
  },
  "browserYogaNames": [
    "Vishkambha",
    "Priti",
    "Ayushman",
    "Saubhagya",
    "Shobhana",
    "Atiganda",
    "Sukarma",
    "Dhriti",
    "Shula",
    "Ganda",
    "Vriddhi",
    "Dhruva",
    "Vyaghata",
    "Harshana",
    "Vajra",
    "Siddhi",
    "Vyatipata",
    "Variyana",
    "Parigha",
    "Shiva",
    "Siddha",
    "Sadhya",
    "Shubha",
    "Shukla",
    "Brahma",
    "Indra",
    "Vaidhriti"
  ],
  "canonicalYogaNames": [
    "Vishkambha",
    "Preeti",
    "Ayushman",
    "Saubhagya",
    "Shobhana",
    "Atiganda",
    "Sukarma",
    "Dhriti",
    "Shoola",
    "Ganda",
    "Vriddhi",
    "Dhruva",
    "Vyaghata",
    "Harshana",
    "Vajra",
    "Siddhi",
    "Vyatipata",
    "Variyan",
    "Parigha",
    "Shiva",
    "Siddha",
    "Sadhya",
    "Shubha",
    "Shukla",
    "Brahma",
    "Indra",
    "Vaidhriti"
  ],
  "nitya": {
    "hardAvoid": [
      "Vaidhriti",
      "Vyatipata"
    ],
    "hardPenalty": -2,
    "partialMinutes": {
      "Vishkambha": 72,
      "Atiganda": 144,
      "Shoola": 120,
      "Ganda": 144,
      "Vyaghata": 216,
      "Parigha": 120
    },
    "partialPenalty": -1,
    "auspicious": [
      "Ayushman",
      "Brahma",
      "Dhriti",
      "Dhruva",
      "Harshana",
      "Indra",
      "Preeti",
      "Sadhya",
      "Saubhagya",
      "Shiva",
      "Shobhana",
      "Shubha",
      "Shukla",
      "Siddha",
      "Siddhi",
      "Sukarma",
      "Vriddhi"
    ],
    "auspiciousBonus": 1
  },
  "specialYoga": {
    "sarvartha": {
      "Adivaram": [
        "Anuradha",
        "Ashvini",
        "Hasta",
        "Mula",
        "Punarvasu",
        "Pushya",
        "Revati",
        "Shravana"
      ],
      "Somavaram": [
        "Anuradha",
        "Mrigashira",
        "Pushya",
        "Rohini",
        "Shravana"
      ],
      "Mangalavaram": [
        "Ashlesha",
        "Ashvini",
        "Krittika",
        "Uttara Ashadha",
        "Uttara Bhadrapada",
        "Uttara Phalguni"
      ],
      "Budhavaram": [
        "Anuradha",
        "Hasta",
        "Krittika",
        "Mrigashira",
        "Rohini"
      ],
      "Guruvaram": [
        "Anuradha",
        "Ashvini",
        "Punarvasu",
        "Pushya",
        "Revati",
        "Swati"
      ],
      "Shukravaram": [
        "Anuradha",
        "Ashvini",
        "Punarvasu",
        "Pushya",
        "Revati",
        "Shravana"
      ],
      "Shanivaram": [
        "Rohini",
        "Shravana",
        "Swati"
      ]
    },
    "amrita": {
      "Adivaram": "Hasta",
      "Somavaram": "Mrigashira",
      "Mangalavaram": "Ashvini",
      "Budhavaram": "Anuradha",
      "Guruvaram": "Pushya",
      "Shukravaram": "Revati",
      "Shanivaram": "Rohini"
    },
    "visha": {
      "Adivaram": 5,
      "Somavaram": 6,
      "Mangalavaram": 7,
      "Budhavaram": 8,
      "Guruvaram": 9,
      "Shukravaram": 10,
      "Shanivaram": 11
    },
    "dagdha": {
      "Adivaram": [
        12
      ],
      "Somavaram": [
        11
      ],
      "Mangalavaram": [
        5
      ],
      "Budhavaram": [
        2,
        3
      ],
      "Guruvaram": [
        6
      ],
      "Shukravaram": [
        8
      ],
      "Shanivaram": [
        9
      ]
    },
    "pushkaraVaras": [
      "Adivaram",
      "Mangalavaram",
      "Shanivaram"
    ],
    "dviTithis": [
      2,
      7,
      12
    ],
    "dviNakshatras": [
      "Chitra",
      "Dhanishtha",
      "Mrigashira"
    ],
    "triTithis": [
      2,
      7,
      12
    ],
    "triNakshatras": [
      "Krittika",
      "Punarvasu",
      "Purva Bhadrapada",
      "Uttara Ashadha",
      "Uttara Phalguni",
      "Vishakha"
    ]
  },
  "horaLords": [
    "Sun",
    "Venus",
    "Mercury",
    "Moon",
    "Saturn",
    "Jupiter",
    "Mars"
  ],
  "horaWeekdayStarts": [
    0,
    3,
    6,
    2,
    5,
    1,
    4
  ],
  "homaLords": [
    "Surya",
    "Budha",
    "Shukra",
    "Shani",
    "Chandra",
    "Mangala",
    "Guru",
    "Rahu",
    "Ketu"
  ],
  "homaBenefics": [
    "Budha",
    "Chandra",
    "Guru",
    "Shukra"
  ],
  "shaniConditions": [
    "Sade Sati (peak phase)",
    "Sade Sati (setting phase)",
    null,
    "Ardhastama Shani",
    null,
    null,
    null,
    "Ashtama Shani",
    null,
    null,
    null,
    "Sade Sati (rising phase)"
  ]
}
